import React, { useEffect, useState } from 'react'
import MySelect from '../../../../../../../UI/form/MySelect'

const PaymentTypeSelect = ({ required, setValidate, setValueForm, forciblyValue }) => {

	// console.log('forciblyValue', forciblyValue)

  	const [value, setValue] = useState(
		forciblyValue && forciblyValue === true ? 'yes' :
		forciblyValue === false ? 'no' : forciblyValue
	)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'prepayment',
			name: 'Передсплата'
		},
		{
			id: 'postpaid',
			name: 'Післяплата'
		},
		// {
		// 	id: 'pay',
		// 	name: 'Оплачено'
		// },
	])

	// useEffect(() => {
	// 	getUnitMeasures()
	// }, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUnitMeasures = () => {
		// getGoodTypesAllAPI().then(data => {
		// 	setGoodTypes(data)
		// }).catch(e => {
		// 	// setError(responseError(e))
		// 	console.error(responseError(e))
		// })
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Тип оплати"
        labelId="select__paymentType-label"
        id='select__paymentType'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Тип оплати'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default PaymentTypeSelect